import { Adjustments } from "@/core/types"

const cameraProfiles: Record<string, Record<string, Partial<Adjustments>>> = {
	SONY: {
		"ILCE-7RM3": { exposure: -0.15 },
	},
	"LEICA CAMERA AG": {
		"LEICA Q3": { exposure: -0.15 },
	},
}

export function getCameraAdjustments(
	maker: string,
	model: string,
): Partial<Adjustments> | undefined {
	return cameraProfiles[maker.trim().toUpperCase()]?.[model.trim().toUpperCase()]
}
